import 'react-sliding-pane/dist/react-sliding-pane.css';
import 'react-toastify/dist/ReactToastify.css';
import 'src/style/toop-tip/tooltip.scss';
import './App.scss';
import './index.scss';

import { CookiesProvider } from 'react-cookie';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import { store } from './app/store';
import { AuthProvider } from './contexts/AuthContext';
import { CompanyProvider } from './contexts/CompanyContext';
import { ConfirmContextProvider } from './contexts/ConfirmContext';
import { DialogProvider } from './contexts/DialogContext';
import LocaleContextProvider from './contexts/LocaleContext';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <DialogProvider>
    <AuthProvider>
      <LocaleContextProvider>
        <CompanyProvider>
          <HelmetProvider>
            <BrowserRouter>
              <Provider store={store}>
                <CookiesProvider>
                  <ConfirmContextProvider>
                    <App />
                  </ConfirmContextProvider>
                </CookiesProvider>
              </Provider>
            </BrowserRouter>
          </HelmetProvider>
        </CompanyProvider>
      </LocaleContextProvider>
    </AuthProvider>
  </DialogProvider>
);

reportWebVitals();
